import {customSpringAxios} from "../backendAPIs";

export async function getLineStationsByLineIdApi(lineId) {
    return await customSpringAxios.get(`/lineStation/line/${lineId}?size=2000&sort=departureTime,asc`)
}
